export const PRODUCER_ROLE: string = 'producer';
